import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SectionDivision03.module.scss';
import { Button } from '../../Button';
import { useLanguage } from '../../../contexts/LanguageContext';

interface SectionDivision03Props {
  i18nPrefix?: string;
  imageMain?: string;
  imageCourse2?: string;
}

export const SectionDivision03: React.FC<SectionDivision03Props> = ({
  i18nPrefix = 'home',
  imageMain,
  imageCourse2,
}) => {
  const { t } = useTranslation();
  const { selectedLanguage } = useLanguage();

  // Funções de navegação
  const navigateWithReload = (path: string) => {
    window.location.href = path;
  };

  const handleWhatWeDo = () => {
    navigateWithReload("/o-que-fazemos");
  };
  
  const handleRegist = () => {
    navigateWithReload(`${process.env.REACT_APP_NEXT_INTAKE_URL}/subscribe?lang=${selectedLanguage}`);
  };

  // Imagens padrão
  const defaultImageMain = require('../../../Assets/images/course.png');
  const defaultImageCourse2 = require('../../../Assets/images/course2.png');

  return (
    <section className={styles.division03}>
      <div className="container px-5">
        <div className={`text-center ${styles.title03} ${styles.deviceDivision03}`}> 
          <span>{t(`${i18nPrefix}.title3_1`)}</span><br/>{t(`${i18nPrefix}.title3_2`)}<br />{t(`${i18nPrefix}.title3_3`)}
        </div>
        <div className={`text-center ${styles.title03} ${styles.deviceDivision03_01}`}>
          <span>{t(`${i18nPrefix}.title3_1`)}</span><br/>{t(`${i18nPrefix}.title3_2`)}{t(`${i18nPrefix}.title3_3`)}
        </div>
        <div className="col-lg-12 d-flex justify-content-center">
          <div className="masthead-device-mockup">
            <img src={imageMain || defaultImageMain} style={{ width: '100%', height: '100%' }} alt="Imagem" />
          </div>
        </div>
        <div className={styles.subTitle03}>
          {t(`${i18nPrefix}.subtitle3_1`)}<br />{t(`${i18nPrefix}.subtitle3_2`)}<br />{t(`${i18nPrefix}.subtitle3_3`)}
        </div>
        <div className={`d-flex flex-column flex-lg-row align-items-center justify-content-center flex-wrap ${styles.deviceDivision03}`}>
          <div className="me-lg-3 mb-4 mb-lg-0" onClick={handleWhatWeDo}>
            <Button name={t(`${i18nPrefix}.button_o_que_fazemos`)} typeButton="secondary" color="black" />
          </div>
          <div onClick={handleRegist}>
            <Button name={t(`${i18nPrefix}.button_cadastre_agora`)} typeButton="primary" />
          </div>
        </div>
        <div className={`d-flex flex-lg-row align-items-center justify-content-center flex-wrap ${styles.deviceDivision03_01}`} style={{ marginTop: '68px' }}>
          <div className="me-lg-3 mb-lg-0 m-2" onClick={handleWhatWeDo}>
            <Button name={t(`${i18nPrefix}.button_o_que_fazemos`)} typeButton="secondary" color="black" />
          </div>
          <div className="m-2" onClick={handleRegist}>
            <Button name={t(`${i18nPrefix}.button_cadastre_agora`)} typeButton="primary" />
          </div>
        </div>
      </div>
      <div className={`col-lg-12 ${styles.imageCourse2}`}>
        <div className="masthead-device-mockup">
          <img src={imageCourse2 || defaultImageCourse2} alt="Imagem" />
        </div>
      </div>
    </section>
  );
}; 